/* zweiherzig — Warenkorbbilder und Beschriftungen

   1) Dawn setzt die Bilder in der Schublade auf loading="lazy" UND visibility:hidden.
      Ein unsichtbares Bild laedt der Browser nie nach — hier wird beides aufgehoben.
   2) Kassen-Button kuerzen: „Auschecken“ → „Zur Kasse“ bzw. „Check out“ → „Checkout“.
      Die Sprache kommt aus <html lang>. */
(function () {
  "use strict";

  var EN = (document.documentElement.lang || "de").toLowerCase().indexOf("en") === 0;

  function bilder(){
    var imgs = document.querySelectorAll('cart-drawer img, .cart-item__image');
    for (var i = 0; i < imgs.length; i++) {
      var im = imgs[i];
      if (im.loading === "lazy") im.loading = "eager";
      im.style.visibility = "visible";
      if (!im.complete || im.naturalWidth === 0) {
        var s = im.getAttribute("src");
        if (s) im.setAttribute("src", s);
      }
    }
  }

  function texte(){
    var d = document.querySelector("cart-drawer");
    if (!d) return;
    var btn = d.querySelector(".cart__checkout-button, #CartDrawer-Checkout, [name=checkout]");
    if (!btn) return;
    var t = (btn.textContent || "").trim();
    if (EN) {
      if (/^check\s?out$/i.test(t)) btn.textContent = "Checkout";
    } else {
      if (/auschecken/i.test(t)) btn.textContent = "Zur Kasse";
    }
  }

  function lauf(){ bilder(); texte(); }

  function start(){
    var d = document.querySelector("cart-drawer");
    if (!d) return;
    lauf();
    new MutationObserver(function(){ lauf(); })
      .observe(d, { childList:true, subtree:true, attributes:true, attributeFilter:["class"] });
    document.addEventListener("click", function(e){
      if (e.target.closest(".product-form__submit, [data-zwh-add], #cart-icon-bubble, .quantity__button")) {
        setTimeout(lauf, 400);
        setTimeout(lauf, 1200);
      }
    });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
  else start();
})();
